import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MobileFriendlyEcommerceWebsiteDevelopmentInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Mobile-Friendly E-commerce Website Development in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Mobile-First Commerce</Subheading>}
        heading={
          <Heading>
            Mobile-Friendly{" "}
            <span tw="text-primary-500">E-commerce Websites</span> in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in mobile-friendly e-commerce
            website development in **Dubai**, creating online stores that
            deliver seamless shopping experiences on smartphones and tablets.
            Reach your mobile audience with ease.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile shopping experience
          "https://images.unsplash.com/photo-1616469829941-c7200edec809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile e-commerce development
          "https://images.unsplash.com/photo-1556740772-1a741367b93e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Customer using mobile shopping app
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Mobile Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Mobile-Optimized E-commerce in Dubai"
        description="We craft stores that shine on every device."
        cards={[
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Responsive Design",
            description: "Adapts perfectly to all screen sizes.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Mobile Sales Boost",
            description: "Optimized for higher conversions on mobile.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Mobile Load Times",
            description: "Quick performance for on-the-go shoppers.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Mobile Features",
            description: "Tailored functionalities for mobile users.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Mobile Shopping",
            description: "Safe transactions on every device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Developers",
            description: "Dubai’s experts in mobile e-commerce.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Mobile-Friendly Development Process"
        description={
          <Description>
            We build mobile-optimized stores with expertise:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Focus on mobile user needs and goals.</li>
              <li>Design: Create responsive, intuitive layouts.</li>
              <li>Development: Build mobile-first features and speed.</li>
              <li>Testing: Ensure flawless performance on all devices.</li>
              <li>Launch: Deliver a mobile-ready online store.</li>
              <li>Support: Maintain and enhance mobile functionality.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1555774698-0b77e0d5fac6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile website development
          "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team collaborating on mobile design
          "https://images.unsplash.com/photo-1481437156560-3205f6a55735?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile responsive testing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Mobile-Friendly Success in Dubai"
        description="Our mobile stores drive real results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Mobile Sales Surge",
            description: "Increased mobile revenue by 150%.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Deployment",
            description: "Mobile store live in just 12 days.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "98% satisfaction with mobile design.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Mobile Success?</Subheading>}
        heading="Mobile-Friendly E-commerce Websites in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for mobile-friendly e-commerce website
            development in Dubai. Reach customers on every device with a
            top-notch online store—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1586880244406-556ebe35f282?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile e-commerce success
          "https://images.unsplash.com/photo-1559526324-593bc073d938?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai skyline with person using smartphone
          "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile payment/checkout
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
